import { SEOContentFAQ } from "../../../../components/seo/SEOContentFAQ";
import { SEOContentHowTo } from "../../../../components/seo/SEOContentHowTo";
import { SEOImage } from "../../../../components/seo/SEOImage";
import { SEORelatedLinks } from "../../../../components/seo/SEORelatedLinks";

export const TeleprompterParaYoutubersPT = () => (
    <>
        <p className="lead text-xl text-slate-300 mb-8 font-medium">
            Domine suas câmeras, grave vídeos impecáveis e impulsione seu canal. Descubra como youtubers e criadores de conteúdo usam o PromptNinja para transformar suas produções de forma simples, natural e profissional.
        </p>

        <p className="text-slate-300 mb-8">
            Você conhece a dor: você liga a câmera, fala duas frases, trava. "Corta, de novo". Você olha para o roteiro no colo, volta para a lente, perde o fio da meada. No final do dia, você tem horas de material bruto para um vídeo de poucos minutos. E o pior: a edição vira um pesadelo de cortes para esconder os erros, matando a fluidez do vídeo.
        </p>

        <SEOImage
            slug="teleprompter-para-youtubers-e-criadores"
            src="teleprompter-for-youtubers-setup.webp"
            alt="Criador de conteúdo usando teleprompter"
            caption="Youtubers profissionais usam teleprompter para reduzir o tempo de edição e aumentar a autoridade."
            width={1200}
            height={675}
            priority={true}
        />

        <div className="bg-blue-600/10 border border-blue-500/20 rounded-2xl p-6 md:p-8 text-center mb-12">
            <h3 className="text-2xl font-bold text-white mb-4">Pronto para Mudar Seu Workflow?</h3>
            <p className="text-slate-300 mb-6">
                Reduza o tempo de gravação em 50% e elimine a frustração de esquecer o texto.
                O <strong>PromptNinja</strong> é o parceiro secreto dos maiores criadores.
            </p>
            <a href="https://promptninja.solutionkit.com.br/#app" className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full transition-all hover:scale-105 shadow-lg shadow-blue-500/25">
                Experimentar Gratuitamente Agora
            </a>
        </div>

        <div className="bg-slate-800 p-8 rounded-xl border-l-4 border-red-500 mb-12 shadow-2xl">
            <h3 className="text-2xl font-bold text-white mb-4">O Algoritmo Odeia Insegurança</h3>
            <div className="grid md:grid-cols-2 gap-8">
                <div>
                    <h3 className="text-lg font-bold text-red-300 mb-2">📉 Sem Teleprompter</h3>
                    <ul className="space-y-2 text-slate-400 text-sm">
                        <li>Olhar desviando (lendo notas) = Quebra de conexão.</li>
                        <li>Muitos "Ahhh", "Éhhh" = Queda na retenção.</li>
                        <li>Edição picotada = Cansaço visual.</li>
                        <li>Resultado: O espectador sai em 30 segundos.</li>
                    </ul>
                </div>
                <div>
                    <h3 className="text-lg font-bold text-green-400 mb-2">📈 Com PromptNinja</h3>
                    <ul className="space-y-2 text-slate-300 text-sm">
                        <li>Olho no olho 100% do tempo = Autoridade.</li>
                        <li>Fala contínua e segura = "Flow" hipnótico.</li>
                        <li>Edição mínima = Vídeo pronto em minutos.</li>
                        <li>Resultado: Watch Time (Tempo de Exibição) dispara.</li>
                    </ul>
                </div>
            </div>
        </div>

        <SEOImage
            slug="teleprompter-para-youtubers-e-criadores"
            src="teleprompter-interface-mobile-speed-control.webp"
            alt="Interface de controle de velocidade do teleprompter no celular"
            caption="Controle a velocidade e o tamanho do texto em tempo real diretamente do seu dispositivo móvel."
            width={1200}
            height={675}
        />

        <h3 className="text-3xl font-bold text-white mt-12 mb-6">3 Formas de Usar (Do Iniciante ao Pro)</h3>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-slate-900/50 p-6 rounded-lg border border-slate-700 hover:border-blue-500 transition">
                <div className="text-3xl mb-4">💻</div>
                <h3 className="text-xl font-bold text-white mb-2">1. O "Laptop Studio"</h3>
                <p className="text-sm text-slate-400 mb-4">Ideal para Webcam / Lives.</p>
                <p className="text-slate-300 text-sm">
                    Coloque a janela do PromptNinja no topo da tela, bem abaixo da webcam do notebook.
                    <br /><strong>Custo: R$ 0.</strong>
                </p>
            </div>

            <div className="bg-slate-900/50 p-6 rounded-lg border border-slate-700 hover:border-purple-500 transition">
                <div className="text-3xl mb-4">📱</div>
                <h3 className="text-xl font-bold text-white mb-2">2. O "Mobile Creator"</h3>
                <p className="text-sm text-slate-400 mb-4">Ideal para Reels/Shorts.</p>
                <p className="text-slate-300 text-sm">
                    Use o PromptNinja no celular. Segure o celular perto da lente da câmera principal se estiver gravando alguém, ou use frontal.
                </p>
            </div>

            <div className="bg-slate-900/50 p-6 rounded-lg border border-slate-700 hover:border-green-500 transition">
                <div className="text-3xl mb-4">📽️</div>
                <h3 className="text-xl font-bold text-white mb-2">3. O "Pro Glass"</h3>
                <p className="text-sm text-slate-400 mb-4">Ideal para Câmeras DSLR.</p>
                <p className="text-slate-300 text-sm">
                    Use um iPad com PromptNinja deitado sob um suporte de vidro (beam splitter). Ative o <strong>Modo Espelho</strong> (Tecla 'M').
                </p>
            </div>
        </div>

        <div className="bg-slate-900/80 p-8 rounded-2xl border border-slate-800 shadow-xl my-12">
            <h3 className="text-3xl font-bold text-white mb-8 text-center">🎬 Veja o PromptNinja em Ação: Casos de Sucesso</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-sm">
                <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700">
                    <div className="text-blue-400 text-2xl mb-4">📚</div>
                    <h4 className="font-bold text-white mb-2">O Educador Detalhista</h4>
                    <p className="text-slate-400 mb-3"><strong>Desafio:</strong> Apresentar tutoriais complexos sem cortes excessivos.</p>
                    <p className="text-slate-300">"Minhas aulas ficaram muito mais profissionais. O PromptNinja garante que cada passo seja explicado com clareza, sem eu me perder em detalhes técnicos."</p>
                </div>
                <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700">
                    <div className="text-blue-400 text-2xl mb-4">🤳</div>
                    <h4 className="font-bold text-white mb-2">O Vlogueiro Espontâneo</h4>
                    <p className="text-slate-400 mb-3"><strong>Desafio:</strong> Manter a naturalidade em vídeos longos.</p>
                    <p className="text-slate-300">"Uso bullet points no teleprompter. Isso me dá liberdade para improvisar sem esquecer os pontos cruciais do vídeo. Parece que não estou usando nada!"</p>
                </div>
                <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700">
                    <div className="text-blue-400 text-2xl mb-4">🔍</div>
                    <h4 className="font-bold text-white mb-2">O Resenhista</h4>
                    <p className="text-slate-400 mb-3"><strong>Desafio:</strong> Precisão técnica e autoridade na fala.</p>
                    <p className="text-slate-300">"Falar sobre especificações técnicas era um pesadelo. Com o roteiro na tela, passo confiança e autoridade para quem está assistindo."</p>
                </div>
            </div>
        </div>

        <h3 className="text-3xl font-bold text-white mt-12 mb-6">Workflow Ninja: Roteiro à Publicação em 1h</h3>
        <SEOContentHowTo
            title=""
            schemaTitle="Como Gravar Vídeos YouTube com Teleprompter"
            totalTime="PT15M"
            tools={["PromptNinja", "Câmera", "Microfone"]}
            steps={[
                {
                    title: "1. Escreva Falando",
                    text: "Não escreva como um livro. Escreva como você fala. Use frases curtas. No PromptNinja, quebre as linhas onde você quer respirar."
                },
                {
                    title: "2. Ajuste a 'Zona de Leitura'",
                    text: "Não deixe o texto ocupar a tela toda. Diminua a margem lateral no PromptNinja para que seus olhos não fiquem 'varrendo' da esquerda para a direita. O texto deve ficar num centro estreito."
                },
                {
                    title: "3. O Truque da Distância",
                    text: "Fique a pelo menos 1 metro da câmera. Quanto mais longe, menos se percebe o movimento dos olhos."
                },
                {
                    title: "4. Ação!",
                    text: "Dê o Play (Espaço). Sorria. Fale com energia (20% a mais que o normal). Se errar, PAUSE, respire e volte uma frase. Não pare a gravação."
                }
            ]}
        />

        <div id="guia-youtuber" className="mt-16 bg-gradient-to-r from-red-600/20 to-red-900/20 p-8 rounded-xl border border-red-500/30">
            <h3 className="text-2xl font-bold text-white mb-4">A Estrutura do Script de Sucesso (Hook-Value-CTA)</h3>
            <p className="text-slate-300 mb-6">
                Não basta ler; é preciso engajar. O segredo dos grandes canais (MrBeast, Ali Abdaal) é a estrutura:
            </p>
            <div className="grid md:grid-cols-3 gap-4 mb-8 text-sm">
                <div className="bg-black/20 p-4 rounded-lg">
                    <strong className="text-red-400 block mb-1">1. O Gancho (0-15s)</strong>
                    <span>Prometa o resultado. Olhe fixamente para a lente usando o PromptNinja para não gaguejar no momento mais importante.</span>
                </div>
                <div className="bg-black/20 p-4 rounded-lg">
                    <strong className="text-red-400 block mb-1">2. O Valor (O Meio)</strong>
                    <span>Use Bullet Points. O PromptNinja permite que você guie seu pensamento sem ler palavra por palavra, mantendo a naturalidade.</span>
                </div>
                <div className="bg-black/20 p-4 rounded-lg">
                    <strong className="text-red-400 block mb-1">3. A Chamada (CTA)</strong>
                    <span>Não esqueça de pedir o like. Com o roteiro na tela, você nunca mais vai esquecer de vender seu peixe.</span>
                </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
                <a href="https://promptninja.solutionkit.com.br/#app" className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-full font-bold transition text-center shadow-lg shadow-red-600/20">
                    Começar a Gravar Agora
                </a>
            </div>
        </div>

        <SEOContentFAQ
            title="Dúvidas de Criadores"
            items={[
                {
                    question: "O YouTube penaliza leitura?",
                    answer: "Pelo contrário. O algoritmo ama Watch Time. Se você fala bem, sem pausas chatas, a pessoa assiste até o fim. O YouTube não sabe se você está lendo, ele só sabe que o público não saiu do vídeo."
                },
                {
                    question: "Como parecer natural?",
                    answer: "O segredo é a linguagem corporal. Mexa as mãos. Sorria. Franze a testa. Use o teleprompter apenas como um guia para as palavras, mas coloque emoção na voz. E configure a velocidade um pouco MAIS RÁPIDA que sua leitura confortável para te forçar a falar com energia."
                },
                {
                    question: "Funciona para Shorts e TikTok?",
                    answer: "Perfeito para isso. Em vídeos curtos de 60s, cada segundo conta. Você não pode desperdiçar tempo pensando. Com o roteiro na tela, você entrega o conteúdo em exatos 59 segundos sem gaguejar."
                }
            ]}
        />

        <SEORelatedLinks
            title="Mais para Criadores"
            links={[
                { label: "Scripts Prontos para YouTube", href: "/scripts-para-youtube" },
                { label: "Teleprompter para TikTok e Reels", href: "/teleprompter-tiktok-shorts" },
                { label: "Dicas de Oratória para Vídeo", href: "/dicas-oratoria-video" },
                { label: "Como usar Teleprompter no OBS Studio", href: "/teleprompter-obs-studio" }
            ]}
        />
    </>
);

